import { InspectionScheduleLineItem } from '@/types/response/InspectionScheduleResponses';
import { UserPreferencesResponse } from '@/types/response/userResponses';

export function formatDateParam(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function addDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function todayKey(): string {
  return formatDateParam(new Date());
}

export function formatDateHeader(dateKey: string): string {
  const [year, month, day] = dateKey.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
}

export function getDayOfWeekShort(dateKey: string): string {
  const [year, month, day] = dateKey.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
}

export function getDayOfMonth(dateKey: string): number {
  const [year, month, day] = dateKey.split('-').map(Number);
  return new Date(year, month - 1, day).getDate();
}

export function getMonthLabel(dateKey: string): string {
  const [year, month] = dateKey.split('-').map(Number);
  return new Date(year, month - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function getMonthKey(dateKey: string): string {
  return dateKey.substring(0, 7); // 'YYYY-MM'
}

export function filterByPreferences(
  items: InspectionScheduleLineItem[],
  prefs: UserPreferencesResponse,
): InspectionScheduleLineItem[] {
  return items.filter(item => {
    if (prefs.GroupIds.length > 0 && !prefs.GroupIds.includes(item.SectionId)) return false;
    if (prefs.SiteIds.length > 0 && !prefs.SiteIds.includes(item.SiteId)) return false;
    if (prefs.AreaIds.length > 0 && !prefs.AreaIds.includes(item.ExpertiseAreaId)) return false;
    return true;
  });
}

export function groupByDate(
  items: InspectionScheduleLineItem[],
): Map<string, InspectionScheduleLineItem[]> {
  const map = new Map<string, InspectionScheduleLineItem[]>();
  for (const item of items) {
    if (!item.NextInspectionDate) continue;
    const key = item.NextInspectionDate.substring(0, 10);
    const existing = map.get(key) ?? [];
    existing.push(item);
    map.set(key, existing);
  }
  return new Map([...map.entries()].sort((a, b) => a[0].localeCompare(b[0])));
}
